import Inputmask from "inputmask";
const id_process_number = JSON.parse(document.getElementById('process_number_input_id').textContent);
const ajax_url = document.getElementById('ajax_url_process_number');
Inputmask('99/99999-9').mask(document.getElementById(id_process_number));
const targetModalEl = document.getElementById('popup-modal');
var modal = null;

if (targetModalEl) {
  modal = new window.Modal(targetModalEl);
  document.querySelectorAll('.close-modal').forEach(el => {
    el.onclick = () => modal.hide();
  });
}

if (ajax_url) {
  const searchEl = document.getElementById('search-project');
  searchEl === null || searchEl === void 0 ? void 0 : searchEl.addEventListener('click', () => {
    let processNumber = document.getElementById('id_process_number').value;

    if (processNumber) {
      const btn = document.getElementById('search-project');
      const form = document.getElementById('create-project-form');
      form.classList.add('block-form');
      btn.disabled = true;
      btn.firstElementChild.classList.remove('hidden');
      fetch(ajax_url + new URLSearchParams({
        processNumber: processNumber
      }).toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        return response.json();
      }).then(data => {
        if (data.err) {
          var _modal;

          targetModalEl.querySelector('#popup-message').innerHTML = data.message;
          (_modal = modal) === null || _modal === void 0 ? void 0 : _modal.show();
        } else {
          document.getElementById('id_title').value = data.title;
          document.getElementById('id_modality').value = data.modality;
          document.getElementById('id_resp_name').value = data.resp_name;
          document.getElementById('id_date_start').value = data.date_start;
          document.getElementById('id_date_end').value = data.date_end;
        }
      }).finally(() => {
        btn.disabled = false;
        btn.firstElementChild.classList.add('hidden');
        form.classList.remove('block-form');
      });
    }
  });
}